import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import LoadingSkeleton from './LoadingSkeleton'

function OriginAddeess(props) {
    const { loading, formik } = props
    const [originAddress, setOriginAddress] = useState(false)
    const [originAddressCard, setOriginAddressCard] = useState(true)
    return (
        <>
            {originAddress && <Col lg={9} md={12} className="product-filter-right-content">
                {loading ? <LoadingSkeleton
                    height={450}
                /> :
                    <div className="app-card mb-3" >
                        <div className={`product-filter-card st-border-light`}>
                            <div className="card-content d-block">
                                <Col lg={8}>
                                    <div className="d-flex  flex-column">
                                        <div className="card-icon mb-4" >
                                            <div className="st-fs-16 st-fw-600 st-text-dark">Select a shipping origin that will be used to calculate shipping rates:</div>
                                        </div>
                                        <div>
                                            <span className="d-flex align-items-baseline flex-column mb-3">
                                                <div className="st-fw-600 st-fs-15">
                                                    <input type="radio" id="title"
                                                        className="custom-radio me-2"
                                                        // {...formik.getFieldProps('productExport')}
                                                        value="TITLE"
                                                        name={"productExport"}
                                                        // checked={formik.values.productExport === "TITLE"}
                                                        onChange={e => {
                                                            // formik.setFieldValue("productExport", e.target.value)
                                                        }}
                                                    />{`I ship orders from my company’s address`}</div>
                                                <span className="pad-25-L mt-2">Choose this if the location from where you ship orders and your company’s address are the same place.</span>
                                            </span>
                                            <span className="d-flex align-items-baseline flex-column mb-3">
                                                <div className="st-fw-600 st-fs-15">
                                                    <input type="radio" id="title"
                                                        className="custom-radio me-2"
                                                        // {...formik.getFieldProps('productExport')}
                                                        value="TITLE"
                                                        name={"productExport"}
                                                        // checked={formik.values.productExport === "TITLE"}
                                                        onChange={e => {
                                                            // formik.setFieldValue("productExport", e.target.value)
                                                        }}
                                                    />{`I ship orders from a warehouse or another location`}</div>
                                                <span className="pad-25-L mt-2">Choose this if you are sending orders from somewhere other than your company’s address. Entering the shipping origin address will keep the company address unchanged.</span>
                                            </span>
                                        </div>
                                        <div className="mt-2">
                                            <div className="st-fs-16 st-fw-600 st-text-dark mb-2">Company and shipping origin address</div>
                                            <Row className="pad-12-L">
                                                <Col lg={6} md={12} className="px-0">
                                                    <AppFormikInputInline
                                                        formik={formik}
                                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                                        labelName={""}
                                                        isRequired={false}
                                                        placeholder={"Category Name"}
                                                        formikFieldName={"categoryName"}
                                                    />
                                                </Col>
                                                <Col lg={6} md={12} className="px-0">
                                                    <AppFormikInputInline
                                                        formik={formik}
                                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                                        labelName={""}
                                                        isRequired={false}
                                                        placeholder={"Category Name"}
                                                        formikFieldName={"categoryName"}
                                                    />
                                                </Col>
                                                <Col lg={6} md={12} className="px-0">
                                                    <AppFormikInputInline
                                                        formik={formik}
                                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                                        labelName={""}
                                                        isRequired={false}
                                                        placeholder={"Category Name"}
                                                        formikFieldName={"categoryName"}
                                                    />
                                                </Col>
                                                <Col lg={6} md={12} className="px-0">
                                                    <AppFormikInputInline
                                                        formik={formik}
                                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                                        labelName={""}
                                                        isRequired={false}
                                                        placeholder={"Category Name"}
                                                        formikFieldName={"categoryName"}
                                                    />
                                                </Col>
                                                <Col lg={6} md={12} className="px-0">
                                                    <div className="d-flex">
                                                        <button
                                                            type="submit"
                                                            className={`st-btn st-btn-primary d-flex align-items-center justify-content-center me-2`}
                                                        // disabled={editButtonDisable || Object.keys(formik.errors).length}
                                                        // onClick={handleFormSubmission}
                                                        >
                                                            {/* {
                                                            editButtonLoading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : ( */}
                                                            <span>Save</span>
                                                            {/* )
                                                        } */}
                                                        </button>
                                                        <button className="st-btn st-btn-gray d-flex align-items-center justify-content-center"
                                                            onClick={(e => {
                                                                setOriginAddress(false)
                                                                setOriginAddressCard(true)
                                                            })}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            </div>
                        </div>
                    </div>}
            </Col >}
            {originAddressCard &&
                <Col lg={9} md={12} className="product-filter-right-content">
                    {loading ? <LoadingSkeleton
                        height={120}
                    /> : <div className="app-card mb-3 mb-lg-4 add-criteria">
                        <div className="product-filter-card">
                            <div className="card-content">
                                <div className="card-text" style={{ width: "80%" }}>
                                    <div className="card-header_">
                                        <span>Shipping Origin</span>
                                    </div>
                                    <div className="card-description">
                                        <div>This is the address from where you ship your orders and is used to calculate real-time shipping rates. This may also be the location where customers can pick up their orders.</div>                                                </div>
                                </div>
                                <div className="" style={{ width: "20%" }}>
                                    <button
                                        style={{ width: "100%" }}
                                        type="submit"
                                        className="st-btn st-btn-primary st-btn-sm d-flex align-items-center text-capitalize mt-2 justify-content-center d-flex"
                                        onClick={(e => {
                                            setOriginAddressCard(false)
                                            setOriginAddress(true)
                                        })}
                                    >
                                        <span>Set up origin Address</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>}
                </Col>
            }
        </>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(OriginAddeess)